<template>
    <div class="container-barx2">
        <v-chart  :options="option" ref="ff" autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/polar';
import 'echarts/lib/component/markPoint';
import 'echarts/lib/component/dataZoom';
import 'echarts/lib/component/title';
import 'echarts/lib/component/tooltip'
import 'zrender/lib/svg/svg'



export default {
  name: 'barChartX2',
  inject:['root'],
  props: {  
     rotate:{
       type:Number,
       default:40
     },
     radius:{
       type:Array,
       default:()=>{
          return [0,15,15,0]
       }
     },
     type:{
      type:String,
      default:"member_consumption"
     },
     data:{
       type:Object,
       default:()=>{
         return {
           y: ['广州K11店', '广州北京路225店', '重庆西城天街', '西安熙地港', '深圳光明大仟里', '深圳光明大仟里1', '深圳光明大仟里2'],
           value: [1200, 1200, 1200, 999, 888,111,111]
         }
       }
     }
  },
  data () {  
    return {     
       option:{},
       color:"",
       radius2:this.radius
    }
  },
  methods: {
    //  resizeTheChart() {
    //   if (this.$refs && this.$refs.ff) {
    //     this.$refs.ff.resize();
    //   }}
  },
  mounted () {

    var that=this
    that.icon1=require('../../../assets/no1.png'); 
    that.icon2=require('../../../assets/no2.png'); 
    that.icon3=require('../../../assets/no3.png'); 
    this.ff=this.$refs.ff,
     that.type!="member_consumption"?that.radius2=[0,15,15,0]:that.radius2=[0,0,0,0];
     that.type!="member_consumption"?that.color="#377DFF":that.color="#6648FF";
    that.option = {
        tooltip :{
					formatter:function(params,index){
						var result = ''
            result=params[0].name + "</br>"
            params.forEach(function (item) {
              if(that.type=="member_consumption"){
                if(item.data>1000)
                  {
                    result += "消费:"+ (item.data/1000) + "K</br>"
                  }else{
                   result += "消费:"+ item.data + "</br>"
                  }
              }else{
               
                   result += "活跃会员数:"+ item.data + "</br>"
                  
              }
            })
          
					return result
					},
					// textStyle:{
					// 	fontSize:18
					// },
          trigger: "axis",
          axisPointer: {
            type: "none",
        
          }
				}, 
        grid: {
            top:'10%',
             left: this.root.device=='phone'?'12%':"8%",
            right: '4%',
            bottom: '3%',
            containLabel: true
          
        },
       
        xAxis: {
                axisLabel: {             
                  rotate:this.rotate,
                color:'#FFFFFF',                
                  formatter: function(value,index){
                    var value;
                    if(that.type=="member_consumption"){
                        if (value >=1000) {
                          value = value/1000+'k';
                        }else if(value <1000){
                          value = value;
                        }
                    }
                    else{
                       value = value;
                    }
                   
                    return value
                  }     
               },
             type: 'value',
             axisTick:{show:false},
             splitLine:{ 
                 show: true,
                    lineStyle: {
                      color: '#323645',
                      type: 'solid',
                      width:1,
                      opacity:0.5
                    },
                
              },
            
            
        },
        yAxis: {
        
          
          //  offset:90,
            axisLabel: {  
                color:'#FFFFFF',
                // formatter:function(value,index){
                  
                //   let str= value.length>6?value.substring(0,6) + '...':value
                //    if  (index>2) return `{img${(6-1)-index}|}    {value|${str}}`
                //    else  return `{img3|${6-index}}    {value|${str}}`
                // },
            
                textStyle:{
                          align:"left",
              // width:100,
                        rich:{
                          align:"left",
                             img0:{
                              //  width:16,
                                backgroundColor:{ image:that.icon1}
                            },
                            img1:{
                              //  width:16,
                                 backgroundColor:{ image:that.icon2 }
                            },
                            img2:{
                              //  width:16,
                                backgroundColor:{ image:that.icon3}
                            },
                             img3:{
                              //  padding: [0, 0, 0, 5]
                            }
                        }
                },
             },
            axisTick:{show:false},
            type: 'category',            
            data: this.data.ydata,
            

        },
       animation:false,
        series: [
           {              
                type: 'bar',                     
                data:this.data.value,
                itemStyle:{
                  normal:{
                     borderType:'solid',
                    barBorderRadius:that.radius2,
                    //color: that.color
                    color:function(params){
                        var c=""
                        if(params.dataIndex==2){
                          c="#EACD2C"
                        }
                        else{
                          c=that.color
                        }
                        return c
                      },      
                    },  
                              
                },
              barWidth:10,
              // emphasis:{
              //   itemStyle:{
              //     color:"#EACD2C"
              //   },
              //   data:[320, 302, 301, 334, 390, 330, 320]
              // }       
            }   
        ]
    };

      //   this.$nextTick(() => {
      //  this.$refs.ff.resize();
      // })

      // window.addEventListener("resize", this.resizeTheChart);//这句在mounted中


  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-barx2{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>